import React, { useEffect } from 'react';
import { CircularProgress } from '@mui/material';
import { useFunctionAsState } from './utilsReact';

const DynamicImport = props => {
	const [component, setComponent] = useFunctionAsState(null);

	useEffect(() => {
		props.load().then(component => {
			setComponent(component.default ? component.default : component);
		});
	}, []);

	return props.children(component, props);
};

const DynamicDefaultCmp = (Component, props) =>
	Component === null ? (
		<CircularProgress color="secondary" />
	) : (
		<Component {...props} />
	);

export { DynamicImport, DynamicDefaultCmp };
